import React, { useState } from 'react';
import { Button, Descriptions, Flex, Modal, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import IntlMessage from '../../../components/IntlMessage';
import { formatCurrency } from '../../../helpers/helpers';
import dayjs from 'dayjs';
import reportApi from '../../../api/report';
import { useIntl } from 'react-intl';
const { Text } = Typography;
const ModalInfoDetail = ({ open, onClose, item }) => {
  let data_detail =
    item?.details &&
    item?.details.length > 0 &&
    item?.details.find(
      (detail) => detail.route_code === '' && detail.route_name === ''
    );
  const intl = useIntl();
  const [loadingExportPdf, setLoadingExportPdf] = useState(false);
  const handleExportPdfData = async () => {
    // Modal.info({
    //   title: 'The function is in development',
    // });
    setLoadingExportPdf(true);
    await reportApi
      .exportDataCloseSellingPdf(item?.userOperator?.id, item.id, {
        limit: 10,
        page: 1,
      })
      .then((data) => {
        setLoadingExportPdf(false);
        // window.open(data.data, '_blank');
      })
      .catch((error) => {
        console.error(error);
        setLoadingExportPdf(false);
        Modal.error({
          title: error,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
      })
      .finally(function () {
        setLoadingExportPdf(false);
      });
    setLoadingExportPdf(false);
  };
  return (
    <Modal
      title={<IntlMessage id="global.cashier_detail" />}
      open={open}
      width={'90%'}
      className="modal_cashier"
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key={'ok'} type="primary" onClick={onClose}>
          <IntlMessage id="global.ok" />
        </Button>,
      ]}>
      <Flex justify="end" style={{ marginBottom: '10px' }}>
        <Button
          type="primary"
          onClick={handleExportPdfData}
          loading={loadingExportPdf}>
          <IntlMessage id="global.export" />
        </Button>
      </Flex>
      <Descriptions bordered>
        <Descriptions.Item span={3} label={<IntlMessage id="global.company" />}>
          {item?.userOperator?.operator?.title}
        </Descriptions.Item>
        {/* <Descriptions.Item span={3} label={<IntlMessage id="global.email" />}>
          {item?.email}
        </Descriptions.Item> */}
        {/* <Descriptions.Item span={1} label={<IntlMessage id="global.city" />}>
          {item?.city}
        </Descriptions.Item> */}
        {/* <Descriptions.Item span={3} label={<IntlMessage id="global.mobile" />}>
          {item?.userOperator?.user?.mobile}
        </Descriptions.Item> */}
        <Descriptions.Item span={3} label={<IntlMessage id="global.agent" />}>
          <Space direction="vertical">
            <Text>
              {item?.userOperator?.user?.firstname +
                ' ' +
                item?.userOperator?.user?.lastname}
            </Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.close_cashier" />}>
          <Space direction="vertical">
            <Text>{dayjs(item?.close_date).format('DD/MM/YYYY HH:mm')}</Text>
          </Space>
        </Descriptions.Item>

        {/* <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.balance_pending" />}>
          {formatCurrency(item?.total_not_paid_tickets)}
        </Descriptions.Item> */}
        {/* <Descriptions.Item span={3} label={<IntlMessage id="global.total" />}>
          {formatCurrency(Number(item?.total_paid_tickets || 0))}
        </Descriptions.Item> */}

        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.first_sale" />}>
          <Space direction="vertical">
            <Text>Référence: {item?.order_first_sale?.order_no}</Text>
            <Text>
              Date: {dayjs(item?.first_date).format('DD/MM/YYYY HH:mm')}
            </Text>
          </Space>
        </Descriptions.Item>

        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.last_sale" />}>
          <Space direction="vertical">
            <Text>Référence: {item?.order_last_sale?.order_no}</Text>
            <Text>
              Date: {dayjs(item?.last_date).format('DD/MM/YYYY HH:mm')}
            </Text>
          </Space>
        </Descriptions.Item>

        {/* <Descriptions.Item span={3} label={<IntlMessage id="global.notpaid" />}>
          {item?.not_paid_tickets || 0}
        </Descriptions.Item>
        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.cancelled" />}>
          {item?.cancelled_tickets || 0}
        </Descriptions.Item> */}
        <Descriptions.Item span={3} label={<IntlMessage id="global.routes" />}>
          {item?.details?.length > 0 &&
            item?.details
              .filter((item) => item.is_summary === false)
              .map((detail, index) => (
                <>
                  <div>
                    <IntlMessage id="global.route_name" />:{' '}
                    {detail?.segment?.start_stop?.title} ~{' '}
                    {detail?.segment?.end_stop?.title}{' '}
                    {detail?.segment?.route?.sku &&
                      `( ${detail?.segment?.route?.sku} )`}
                  </div>
                  <div>
                    <IntlMessage id="global.number_of_paid_ticket" />:{' '}
                    {detail?.paid_tickets ?? 0}
                  </div>
                  <div>
                    <IntlMessage id="global.total" />:{' '}
                    {formatCurrency(detail?.total_paid ?? 0)}
                  </div>
                  <div>
                    <IntlMessage id="global.number_of_unpaid_ticket" />:{' '}
                    {detail?.not_paid_tickets || 0}
                  </div>
                  <div>
                    <IntlMessage id="global.total" />:{' '}
                    {formatCurrency(detail?.total_not_paid ?? 0)}
                  </div>

                  {index <
                    item?.details.filter((item) => item.is_summary === false)
                      .length -
                      1 && <hr />}
                </>
              ))}
          <hr />
          <div style={{ fontWeight: 'bold' }}>
            <IntlMessage id="global.global" />
          </div>
          <div>
            <IntlMessage id="global.number_of_paid_ticket" />:{' '}
            {item?.paid_tickets ?? 0}
          </div>
          <div>
            <IntlMessage id="global.total" />:{' '}
            {formatCurrency(item?.total_paid_tickets ?? 0)}
          </div>
          <div>
            <IntlMessage id="global.number_of_unpaid_ticket" />:{' '}
            {item?.not_paid_tickets || 0}
          </div>
          <div>
            <IntlMessage id="global.total" />:{' '}
            {formatCurrency(item?.total_not_paid_tickets ?? 0)}
          </div>
        </Descriptions.Item>

        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.first_bagage" />}>
          <Space direction="vertical">
            <Text>Référence: {item?.data_luggage_summary?.first_luggage}</Text>
            <Text>
              Date:{' '}
              {dayjs(item?.data_luggage_summary?.first_date).format(
                'DD/MM/YYYY HH:mm'
              )}
            </Text>
          </Space>
        </Descriptions.Item>

        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.last_bagage" />}>
          <Space direction="vertical">
            <Text>Référence: {item?.data_luggage_summary?.last_luggage}</Text>
            <Text>
              Date:{' '}
              {dayjs(item?.data_luggage_summary?.last_date).format(
                'DD/MM/YYYY HH:mm'
              )}
            </Text>
          </Space>
        </Descriptions.Item>
        <Descriptions.Item span={3} label={<IntlMessage id="global.bagages" />}>
          {item?.data_luggage_summary?.data_luggage_detail?.length > 0 &&
            item?.data_luggage_summary?.data_luggage_detail.map(
              (detail, index) => (
                <>
                  <div style={{ fontWeight: 'bold' }}>{detail?.title}</div>
                  <div>
                    <IntlMessage id="global.nombre" />: {detail?.extra?.number}
                  </div>
                  <div>
                    <IntlMessage id="global.total" />:{' '}
                    {formatCurrency(detail?.extra?.total ?? 0)}
                  </div>
                  {index <
                    item?.data_luggage_summary?.data_luggage_detail.length -
                      1 && <hr />}
                </>
              )
            )}
          <hr />
          <div style={{ fontWeight: 'bold' }}>
            <IntlMessage id="global.global" />
          </div>
          <div>
            <IntlMessage id="global.nombre" />:{' '}
            {item?.data_luggage_summary?.global_total?.qty ?? 0}
          </div>
          <div>
            <IntlMessage id="global.total" />:{' '}
            {formatCurrency(
              item?.data_luggage_summary?.global_total?.total ?? 0
            )}
          </div>
        </Descriptions.Item>

        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.total_general" />}>
          {formatCurrency(
            (item?.total_paid_tickets || 0) +
              (item?.data_luggage_summary?.global_total?.total || 0)
          )}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

ModalInfoDetail.propType = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

ModalInfoDetail.defaultProps = {
  open: false,
  onClose: () => {},
};

export default ModalInfoDetail;
